export default __webpack_public_path__ + "static/media/x.537bc157.svg";